<template>
 
</template>

<script>
export default {
  name: 'ProjectLogo'
}
</script>
